import { useCampaignEditorContext } from '../state/hooks/useCampaignEditorContext';
import { useTranslation } from 'react-i18next';
import { StatusChip } from '@salecycle/ui-component-library';
import { StatusChipProps } from '@salecycle/ui-component-library/StatusChip/StatusChip';

export const CampaignStatus = () => {
  const { state } = useCampaignEditorContext();
  const { t } = useTranslation('campaigns');

  const propsLookup: Record<string, StatusChipProps> = {
    DRAFT: {
      'aria-label': t('bulkRetargetingCampaigns.editor.statusAriaLabel'),
      label: t('status.draft'),
      variation: 'Draft',
    },
    SCHEDULED: {
      'aria-label': t('bulkRetargetingCampaigns.editor.statusAriaLabel'),
      label: t('status.scheduled'),
      variation: 'Scheduled',
    },
    TRIGGERED: {
      'aria-label': t('bulkRetargetingCampaigns.editor.statusAriaLabel'),
      label: t('status.triggered'),
      variation: 'Triggered',
    },
  };

  const props = propsLookup[state.status] ?? {
    'aria-label': t('bulkRetargetingCampaigns.editor.statusAriaLabel'),
    label: t('status.live'),
    variation: 'Live',
  };

  return <StatusChip {...props} />;
};
